export var round = function round(number) {
  return Math.round(number * 1e5) / 1e5;
};